<template>
  <div class="c-modal-header card-header border-bottom">
    <slot />
    <c-button theme="close" @click.prevent="closeModal" />
  </div>
</template>
<script>

export default {
  name: 'c-modal-header',
  methods: {
    closeModal() {
      this.$parent.$emit('close');
    }
  }
}
</script>

